import { http } from '@/app/lib/http/client'
import { ListParams } from '../types/pagination'

// ─── Interfaces ───────────────────────────────────────────────────────────────

export interface AccessLog {
    id?: number
    user_name:    string | null
    user_email:   string | null
    user_role:    string | null
    sucursal_name: string | null
    device_name:  string | null
    login_type:   string
    success:      boolean
    ip_address?:  string | null
    logged_in_at: string
}

export interface AccessLogFilters {
    show_all_sucursals?: boolean
    login_type?: string
    success?: boolean
    from?: string
    to?: string
    search?: string
}

// ─── Servicio ─────────────────────────────────────────────────────────────────

export const accessLogService = {
    async getLogs(params?: ListParams & AccessLogFilters) {
        const response = await http.get('/access-logs', { params })
        return response.data
    },
}
